const selectors = {
  pickupContainer: '[data-store-availability-container]',
  shopifySection: '[data-api-content]',
  drawer: '[data-pickup-drawer]',
  drawerOpen: '[data-pickup-drawer-open]',
  drawerClose: '[data-pickup-drawer-close]',
};

const classes = {
  isVisible: 'drawer--visible',
};

let sections = {};

class PickupAvailability {
  constructor(section) {
    this.container = section.container;
    this.drawer = null;
    this.buttonDrawerOpen = null;
    this.buttonDrawerClose = null;

    this.container.addEventListener('theme:variant:change', (event) => this.fetchPickupAvailability(event));
  }

  fetchPickupAvailability(event) {
    const container = this.container.querySelector(selectors.pickupContainer);
    const variant = event.detail.variant;

    if (container && variant) {
      fetch(`${window.theme.routes.root_url}variants/${variant.id}/?section_id=api-pickup-availability`)
        .then((response) => response.text())
        .then((text) => {
          const pickupAvailabilityHTML = new DOMParser().parseFromString(text, 'text/html').querySelector(selectors.shopifySection).innerHTML;
          container.innerHTML = pickupAvailabilityHTML;

          this.drawer = this.container.querySelector(selectors.drawer);
          this.buttonDrawerOpen = this.container.querySelector(selectors.drawerOpen);
          this.buttonDrawerClose = this.container.querySelectorAll(selectors.drawerClose);

          if (this.buttonDrawerOpen) {
            this.buttonDrawerOpen.addEventListener('click', () => this.openDrawer());
          }

          if (this.buttonDrawerClose.length) {
            this.buttonDrawerClose.forEach((element) => {
              element.addEventListener('click', () => this.closeDrawer());
            });
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  openDrawer() {
    if (this.drawer) {
      this.drawer.classList.add(classes.isVisible);
      this.drawer.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true}));
    }
  }

  closeDrawer() {
    if (this.drawer) {
      this.drawer.classList.remove(classes.isVisible);
      this.drawer.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));
    }
  }
}

const pickupAvailability = {
  onLoad() {
    sections[this.id] = new PickupAvailability(this);
  },
};

export default pickupAvailability;
